// Single source of truth for breakpoint pixel values consumed by appSettingsStore
// matchMedia listeners. Aligns with Tailwind @theme breakpoints in tailwind.css.

export const BREAKPOINT_LARGE_MIN = 1200; // Tailwind `l:` and above (≥1200px)
export const BREAKPOINT_TABLET_MAX = 991; // Tailwind `m:` and below (≤991px)
export const BREAKPOINT_SMALL_MAX = 767; // Tailwind `s:` and below (≤767px) — Wave 3 (consumed by Task 0.5 IsBelowSmallBreakpoint listener)
export const BREAKPOINT_MOBILE_MAX = 575; // Tailwind `xs:` and below (≤575px)
